// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__UOckX","links":"Navbar_links__CnGyz","footer":"Navbar_footer__4bBDo"};